<template>
  <v-row align="center">
    <v-col cols="3" class="my-0 py-0">
      <v-select
          class="license-local-select"
          v-model="licenseLocalNumber"
          :items="licenseLocalNumbers"
          item-text="label"
          item-value="value"
          solo
          menu-props="{ offsetY: true }"
          hide-details
          required
          :rules="[v => !!v]"
          label="지역(번호)"
          color="navy"
      ></v-select>
    </v-col>
    <v-col cols="6" class="my-0 py-0">
      <v-text-field v-model="licenseNumber" v-mask="driverMask" placeholder="00-000000-00" solo required :rules="[v => !!v]"
                    hide-details :autofocus="true" color="navy"></v-text-field>
    </v-col>
    <v-col cols="3" class="my-0 py-0">
      <c-btn color="blue" outlined @click="reqLicenseNoDupl" :disabled="licenseNoBtnFlag">중복검사</c-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask';
import { licenseLocalNumbers } from "../plugins/constants";

export default {
  name: 'CDriverRegisterNumber',
  directives: { mask },
  props: {
    licenseNo: {
      type: String
    },
  },
  mounted() {
    // 값 초기화
    if (this.licenseNo) {
      this.licenseLocalNumber = parseInt(this.licenseNo.split('-')[0]);
      this.licenseNumber = this.licenseNo.slice(3, this.licenseNo.length);
      this.formLicenseNo = this.licenseNo
    } else {
      this.licenseNumber = ''
      this.licenseLocalNumber = ''
      this.formLicenseNo = ''
    }
  },
  data: () => ({
    // mask
    driverMask: '##-######-##',

    // select options
    licenseLocalNumbers: licenseLocalNumbers,

    // value
    licenseLocalNumber: '',
    licenseNumber: '',

    // check
    formLicenseNo: '',
  }),
  watch: {
    licenseLocalNumber() {
      this.$emit('update:licenseNo', this.licenseLocalNumber + '-' + this.licenseNumber)
    },
    licenseNumber() {
      this.$emit('update:licenseNo', this.licenseLocalNumber + '-' + this.licenseNumber)
    }
  },
  computed: {
    licenseNoBtnFlag() {
      if(this.formLicenseNo){
        if(this.formLicenseNo === this.licenseNo){
          this.$emit('update:licenseNoFlag', true);
          return true;
        } else {
          this.$emit('update:licenseNoFlag', true);
          return false;
        }
      }
    },
  },
  methods: {
    async reqLicenseNoDupl() {
      try {
        if (this.licenseLocalNumber === '') {
          this.$store.commit('snackbar', {timeout : 2000, msg : '지역번호를 입력해주세요.'});
          return;
        }

        if (this.licenseNumber.length < 12) {
          this.$store.commit('snackbar', {timeout : 2000, msg : '올바른 운전자 등록번호를 입력해주세요'});
          return;
        }

        if (this.licenseNo === '') {
          this.$store.commit('snackbar', {timeout : 2000, msg : '운전자 등록번호를 입력해주세요.'});
          return;
        }
        const response = await this.$api.checkDriverLicenseNo(this.licenseNo);
        if(response.data === true) {
          this.$emit('update:licenseNoFlag', true);
          this.formLicenseNo = this.licenseNo
          this.$store.commit('snackbar', {timeout : 2000 ,msg : '등록 가능한 번호입니다.', color:'blue'});
        } else {
          this.$store.commit('snackbar', {timeout : 2000 ,msg : '이미 등록된 번호입니다.'});
          this.$emit('update:licenseNo', '');
        }
      }catch (err) {
        this.$store.commit('snackbar', {err, where:'reqLicenseNoDupl'});
      }
    },
  }
}

</script>

<style>
.license-local-select {
  align-items: center;
  font-size: 14px;
}
</style>